import { ALL_CARDS_ACCEPTED_HEADING } from '@chegg-wt/core-wa/state/constants'
import { AllCardsAcceptedHeading } from './styled'

const AllCardsAccepted = () => {
  return <AllCardsAcceptedHeading>{ALL_CARDS_ACCEPTED_HEADING}</AllCardsAcceptedHeading>
}

export default AllCardsAccepted
